import { useTheme } from '@emotion/react';
import CloseIcon from '@mui/icons-material/Close';
import { Grid, TextField, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { sendRequest, serviceList } from 'src/utils';
import ButtonAction from '../../../components/Button.js/SaveButton';
import NumberInput from '../../../components/Input/NumberInput';
import TextInput from '../../../components/Input/TextInput';
import Loader from '../../../components/loader/loader';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};
const FindRequestWithCode = ({ visible = false, callBackFunct, setVisible, handleGetOne }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [code, setCode] = useState('');
    const flagRef = React.useRef(false);

    const handleClick = () => {
        if (flagRef.current === true) return;
        if (!code) return toast.error(t('error.param'));

        flagRef.current = false;
        handleGetOne(code);
        callBackFunct && callBackFunct();
    };
    return (
        <Dialog
            open={visible}
            onClose={() => {
                setVisible(false);
            }}
            aria-labelledby="customized-dialog-title"
        >
            <DialogTitle
                onClose={() => {
                    setVisible(!visible);
                }}
                id="customized-dialog-title"
            >
                {t('copy_old_request')}
            </DialogTitle>
            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid item style={{ width: '100%', minWidth: '300px' }} xl={12} md={12} sm={12}>
                        <TextInput label={t('input_code_request')} size="medium" getValue={(e) => setCode(e)} />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions style={{ padding: '12px 16px' }}>
                <ButtonAction
                    onClick={() => {
                        setVisible(!visible);
                    }}
                    type={'cancel'}
                    title={t('cancel')}
                />
                <ButtonAction onClick={handleClick} type={'save'} icon="save" title={t('confirm')} />
            </DialogActions>
        </Dialog>
    );
};

export default FindRequestWithCode;
